import { Droppable } from '@hello-pangea/dnd';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { OptionChip } from './OptionChip';
import { useChipClone } from '@/hooks/questions/dnd/useChipClone';
import { useDragDropAnswerContext } from './DragDropAnswerContext';
import { BANK_ID } from '@/utils/questions/dnd/types';

type TokenBankProps = {
  className?: string;
  ariaLabel?: string;
};

export function TokenBank({ className, ariaLabel }: TokenBankProps) {
  const { bankTokens, disabled, selectedId, onContainerClick, flow } =
    useDragDropAnswerContext();
  const { t } = useTranslation('translation', {
    keyPrefix: 'questionView.dnd',
  });
  const renderClone = useChipClone();

  return (
    <Droppable
      droppableId={BANK_ID}
      direction={flow}
      isDropDisabled={disabled}
      renderClone={renderClone}
    >
      {provided => (
        <div
          ref={provided.innerRef}
          {...provided.droppableProps}
          data-testid="token-bank"
          aria-label={ariaLabel ?? t('bankLabel')}
          aria-roledescription={t('dropZoneRoleDescription')}
          onClick={event => {
            if (event.defaultPrevented) return;
            onContainerClick(BANK_ID);
          }}
          className={twMerge(
            'flex flex-wrap items-center w-full',
            flow === 'vertical' && 'flex-col',
            selectedId && 'cursor-pointer',
            className,
          )}
        >
          {bankTokens.map((token, index) => (
            <OptionChip
              key={token.id}
              token={token}
              index={index}
              className="mr-2 mb-2"
            />
          ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
}
